module.exports = __webpack_public_path__ + "img/mascot-juggling.64e2d722.svg";